import React from 'react';

const WhySignUpModal = ({
  showWhySignUpModal,
  setShowWhySignUpModal
}) => {
  if (!showWhySignUpModal) return null;

  const features = [
    {
      title: '* Unlock Personalized Insights',
      description: 'Get predictions and remedies tailored to your unique birth chart.'
    },
    {
      title: '* Access 1-on-1 Consultations',
      description: 'Connect with expert astrologers for deeper guidance.'
    },
    {
      title: '* Save Your Chats & Reports',
      description: 'Keep a history of your conversations and revisit insights anytime.'
    },
    {
      title: '* Early Access to New Features',
      description: 'Be the first to try upcoming tools and exclusive Beta updates.'
    }
  ];

  return (
    <div className="modal-overlay">
      <div className="birth-details-modal">
        <button className="modal-close-btn" onClick={() => setShowWhySignUpModal(false)}>
          ✕
        </button>

        <div className="modal-header">
          <div className="modal-icon">
            <span
              className="logo-icon"
            ></span>
          </div>
          <h2 className="modal-title">Why Join Us</h2>
          <p className="modal-subtitle">
            Unlock the full power of personalized astrology
          </p>
        </div>

        <div className="waiting-info why-signup-content">
          <ul className="">
            {features.map((feature, index) => (
              <li key={index} className="item">
                <span className="">
                  <strong>{feature.title}</strong> - {feature.description}
                </span>
              </li>
            ))}
          </ul>

          <div className="">
            <p>
              ✨ Signing up takes just a minute - and opens the door to a smarter,
              more personal astrology experience.
            </p>
          </div>

          <div className="contact-section">
            <button
              className="contact-btn"
              onClick={() => setShowWhySignUpModal(false)}
            >
              Let's Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhySignUpModal;
